/*const SideMenuJson = {
  "menus": [
    {
      "MenuTitle": "",
      "item": [
        {
          "title": "Network",
          "path": "/network",
          "auth": false,
          "roles": "",
          "roleContext": "carrier",
          "items": [
            {
              "title": "Manage Network",
              "path": "/network/manageNetwork",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            },
            {
              "title": "Manage Institute",
              "path": "/network/manageInstitute",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            }
          ]
        },
        {
          "title": "Q&A",
          "path": "/q&a",
          "auth": false,
          "roles": "",
          "roleContext": "carrier",
          "items": [
            {
              "title": "Add Question",
              "path": "/q&a/addQuestion",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            }
          ]
        },
        {
          "title": "Favorite",
          "path": "/favorite",
          "auth": false,
          "roles": "",
          "roleContext": "carrier",
          "items": [
            {
              "title": "Manage Favorite",
              "path": "/favorite/manageFavorite",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            },
            {
              "title": "Manage Keyword",
              "path": "/favorite/manageKeyword",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            },
            {
              "title": "Suggested Keyword",
              "path": "/favorite/suggestedKeyword",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            },
            {
              "title": "Popular Favorite Interest",
              "path": "/favorite/popularFavoriteInterest",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            }
          ]
        },
        {
          "title": "Users",
          "path": "/users",
          "auth": false,
          "roles": "",
          "roleContext": "carrier",
          "items": [
            {
              "title": "Manage Users",
              "path": "/users/manageUsers",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            },
            {
              "title": "User Profile",
              "path": "/users/userProfile",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            },
            {
              "title": "Incomplete Profile",
              "path": "/users/incompleteProfile",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            },
            {
              "title": "IP Tracking",
              "path": "/users/ipTracking",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            },
            {
              "title": "Abusive Profiles",
              "path": "/users/abusiveProfiles",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            },
            {
              "title": "Suggested Emails",
              "path": "/users/suggestedEmails",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            },
            {
              "title": "Coupon List",
              "path": "/users/couponList",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            },
            {
              "title": "Invited User List",
              "path": "/users/invitedUserList",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            }
          ]
        },
        {
          "title": "High Schools",
          "path": "/highSchools",
          "auth": false,
          "roles": "",
          "roleContext": "carrier",
          "items": [
            {
              "title": "High School",
              "path": "/highSchools/highSchool",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            },
            {
              "title": "Suggested High Schools",
              "path": "/highSchools/suggestedHighSchools",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            }
          ]
        },
        {
          "title": "Aux",
          "path": "/aux",
          "auth": false,
          "roles": "",
          "roleContext": "carrier",
          "items": [
            {
              "title": "Manage Aux",
              "path": "/aux/manageAux",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            }
          ]
        },
        {
          "title": "Announcement",
          "path": "/announcement",
          "auth": false,
          "roles": "",
          "roleContext": "carrier",
          "items": [
            {
              "title": "Manage Announcement",
              "path": "/announcement/manageAnnouncement",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            },
            {
              "title": "Breast Cancer Record",
              "path": "/announcement/breastCancerRecord",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            },
            {
              "title": "Star Bucks Coffe Cup",
              "path": "/announcement/starBucksCoffeCup",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            },
            {
              "title": "Super Bowl",
              "path": "/announcement/superBowl",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            }
          ]
        },
        {
          "title": "Photos",
          "path": "/photos",
          "auth": false,
          "roles": "",
          "roleContext": "carrier",
          "items": [
            {
              "title": "Manage Photos Categories",
              "path": "/photos/managePhotosCategories",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            },
            {
              "title": "Suggested Categories",
              "path": "/photos/suggestedCategories",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            },
            {
              "title": "Synonym List",
              "path": "/photos/synonymList",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            },
            {
              "title": "View All Photos",
              "path": "/photos/viewAllPhotos",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            }
          ]
        },
        {
          "title": "Help",
          "path": "/help",
          "auth": false,
          "roles": "",
          "roleContext": "carrier",
          "items": [
            {
              "title": "Manage Help",
              "path": "/help/manageHelp",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            }
          ]
        },
        {
          "title": "Content",
          "path": "/content",
          "auth": false,
          "roles": "",
          "roleContext": "carrier",
          "items": [
            {
              "title": "Manage Content",
              "path": "/content/manageContent",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            }
          ]
        },
        {
          "title": "Settings",
          "path": "/settings",
          "auth": false,
          "roles": "",
          "roleContext": "carrier",
          "items": [
            {
              "title": "Change Password",
              "path": "/settings/changePassword",
              "auth": false,
              "roles": "",
              "roleContext": "carrier"
            }
          ]
        }
      ]
    }
  ]
};// */
import { APIGET } from '../services/APIServices';

const [SideMenuJson] = await Promise.all([APIGET("sideMenu.json")]);
// let roleToCheck = localStorage.getItem('role')
function checkRoutesAuth(segment) {
  function findAuthBySegment(items, segment) {
    for (const item of items) {
      const segments = item.path.split('/');
      const lastSegment = segments[segments.length - 1];
      if (item.path && lastSegment === segment) {
        // if(item.roles.includes(roleToCheck))
        return item.auth !== undefined ? item.auth : false;
      }
      if (item.items) {
        const result = findAuthBySegment(item.items, segment);
        if (result !== false) {
          return result;
        }
      }
    }
    return false;
  }

  for (const menu of SideMenuJson.menus) {
    const result = findAuthBySegment(menu.item, segment);
    if (result !== false) {
      return result;
    }
  }

  return false;
}


export {
  SideMenuJson,
  checkRoutesAuth
}
